import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GDSs, LOCALSTORAGEVARS } from 'src/app/core/enums/enums';
import { GDS, SearchForm } from 'src/app/core/models/itinerary.model';
import { SettingsService } from 'src/app/settings/services/settings.service';

@Component({
  selector: 'app-booking-search',
  templateUrl: './booking-search.component.html',
  styleUrls: ['./booking-search.component.scss']
})
export class BookingSearchComponent implements OnInit, OnDestroy {
  @Output() chooseCountry = new EventEmitter<string>();
  @Output() submitBookingSearch = new EventEmitter<SearchForm>();

  form: UntypedFormGroup;
  submitted = false;
  gds: GDS[] = [];
  SEARCH_VALUES = ['pnr', 'tkt'];
  disabledTickets = false;
  valueInput = '';
  enabledReservationNumber = true;
  valueFormTkt: string = '';

  subscriptions = new Subscription();

  constructor(private formBuilder: UntypedFormBuilder, private settingsService: SettingsService) {}

  ngOnInit() {
    this.initForm();
    this.setterGDSOptions();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  initForm() {
    this.form = this.formBuilder.group({
      bookingCode: [''],
      gds: ['', Validators.required],
      searchType: ['pnr', Validators.required],
      pnr: ['', [Validators.maxLength(6), Validators.minLength(6), Validators.required]],
      ticketNumbers: this.formBuilder.array([])
    });

    this.subscriptions.add(this.changeCriteria());
  }

  changeCriteria() {
    return this.form.controls.searchType.valueChanges.subscribe((code) => {
      if (code === 'tkt') {
        this.form.controls.pnr.setValidators(null);
        this.form.controls.ticketNumbers.setValidators([Validators.required]);
      } else {
        this.form.controls.pnr.setValidators([
          Validators.maxLength(6),
          Validators.minLength(6),
          Validators.required
        ]);
        this.form.controls.ticketNumbers.setValidators(null);
      }
      this.form.controls.pnr.updateValueAndValidity();
      this.form.controls.ticketNumbers.updateValueAndValidity();
    });
  }

  addTicketToForm(val: string) {
    const ticktes = this.form.controls.ticketNumbers as UntypedFormArray;
    ticktes.push(this.formBuilder.control(val.toUpperCase()));
    this.disabledTickets = ticktes.length === 9 ? true : false;
  }

  deleteTicket(index: number) {
    const ticktes = this.form.controls.ticketNumbers as UntypedFormArray;
    ticktes.removeAt(index);
  }

  onTktChange(tktValue: string) {
    this.valueFormTkt = tktValue;
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      this.submitBookingSearch.emit(this.form.value);
      const formExchangeLogin = JSON.parse(localStorage.getItem(LOCALSTORAGEVARS.FormExchanges));
      if (formExchangeLogin) {
        localStorage.removeItem(LOCALSTORAGEVARS.FormExchanges);
      }
    }
  }

  trim(value: string) {
    this.valueInput = value.trim();
  }

  setterGDSOptions() {
    this.settingsService
      .getClientSettings()
      .pipe(
        tap((response) => {
          if (!this.gds.length) {
            response?.enabledGdsProviders?.forEach((module) => {
              this.gds.push(GDSs.find((gdsProvider) => module === gdsProvider.id));
            });
          }
        })
      )
      .subscribe();
  }
}
